/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var ModuleDependency = require("./ModuleDependency");

function SingleEntryDependency(request) {
	ModuleDependency.call(this, request);
}
module.exports = SingleEntryDependency;

SingleEntryDependency.prototype = Object.create(ModuleDependency.prototype);
SingleEntryDependency.prototype.constructor = SingleEntryDependency;
SingleEntryDependency.prototype.type = "single entry";



//////////////////
// WEBPACK FOOTER
// (webpack)/lib/dependencies/SingleEntryDependency.js
// module id = 1900
// module chunks = 0